var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-exam-topic main-container"
  }, [(_vm.resData) ? _c('div', {
    staticClass: "box-shadow-small border-radius container"
  }, [_c('div', {
    staticClass: "exam-topic-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.resData.paperName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.resData.examDuration))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.resData.examSummary) + "。")])]), _vm._v(" "), _c('div', {
    staticClass: "exam-topic-body"
  }, [(_vm.resData.singleChoice.length) ? _c('div', {
    staticClass: "box-shadow-small background-white border-radius exam-topic-item"
  }, [_c('h3', [_vm._v(_vm._s(_vm.num2Chinese(_vm.singleSelectIndex)) + "、" + _vm._s(_vm.resData.titles[_vm.singleSelectIndex].title))]), _vm._v(" "), _c('p', [(_vm.subTitle(_vm.singleSelectIndex)) ? _c('span', [_vm._v("(" + _vm._s(_vm.subTitle(_vm.singleSelectIndex)) + " )")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, _vm._l((_vm.resData.singleChoice), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-20"
    }, [_c('h4', [_vm._v(_vm._s(index + 1) + ". "), _c('span', {
      staticClass: "ques-txt",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("（"), _c('span', {
      key: index,
      class: _vm.answerColor(_vm.singleChoiceData, index)
    }, [_vm._v(_vm._s(_vm.singleChoiceData.user[index]))]), _vm._v("）")])]), _vm._v(" "), _c('ul', {
      staticClass: "exam-topic-options"
    }, _vm._l((item.options), function(option, opIndex) {
      return _c('li', {
        key: opIndex
      }, [_vm._v(_vm._s(_vm.num2letter(opIndex + 1)) + "." + _vm._s(option.content))])
    }), 0), _vm._v(" "), _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("正确答案："), _c('span', [_vm._v(_vm._s(_vm.resData.correctAnswers[item.id] ? _vm.resData.correctAnswers[item.id][0].content : '-'))])]), _vm._v(" "), (item.analysis) ? _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("答案分析："), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.analysis)
      }
    })]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "score-line"
  })]) : _vm._e(), _vm._v(" "), (_vm.resData.multipleChoice.length) ? _c('div', {
    staticClass: "box-shadow-small background-white border-radius exam-topic-item"
  }, [_c('h3', [_vm._v(_vm._s(_vm.num2Chinese(_vm.multiSelectIndex)) + "、" + _vm._s(_vm.resData.titles[_vm.multiSelectIndex].title) + " ")]), _vm._v(" "), _c('p', [(_vm.subTitle(_vm.multiSelectIndex)) ? _c('span', [_vm._v("(" + _vm._s(_vm.subTitle(_vm.multiSelectIndex)) + " )")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, _vm._l((_vm.resData.multipleChoice), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-20"
    }, [_c('h4', [_vm._v(_vm._s(index + 1) + "."), _c('span', {
      staticClass: "ques-txt",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("（"), _c('span', {
      key: index,
      class: _vm.answerColor(_vm.singleChoiceData, index)
    }, [_vm._v(_vm._s(_vm.multipleChoiceData.user[index]))]), _vm._v("）")])]), _vm._v(" "), _c('ul', {
      staticClass: "exam-topic-options"
    }, _vm._l((item.options), function(option, opIndex) {
      return _c('li', {
        key: opIndex
      }, [_vm._v(_vm._s(_vm.num2letter(opIndex + 1)) + "." + _vm._s(option.content))])
    }), 0), _vm._v(" "), _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("正确答案："), _c('span', [_vm._v(_vm._s(_vm.resData.correctAnswers[item.id] ? _vm.resData.correctAnswers[item.id][0].content : '-'))])]), _vm._v(" "), (item.analysis) ? _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("答案分析："), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.analysis)
      }
    })]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "score-line"
  })]) : _vm._e(), _vm._v(" "), (_vm.resData.fillTheBlank.length) ? _c('div', {
    staticClass: "box-shadow-small background-white border-radius exam-topic-item"
  }, [_c('h3', [_vm._v(_vm._s(_vm.num2Chinese(_vm.fillBlackIndex)) + "、" + _vm._s(_vm.resData.titles[_vm.fillBlackIndex].title))]), _vm._v(" "), _c('p', [(_vm.subTitle(_vm.fillBlackIndex)) ? _c('span', [_vm._v("(" + _vm._s(_vm.subTitle(_vm.fillBlackIndex)) + " )")]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((_vm.resData.fillTheBlank), function(item, index) {
    return _c('el-row', {
      key: index
    }, [_c('el-col', {
      attrs: {
        "span": 22
      }
    }, [_c('h4', [_vm._v(_vm._s(index + 1) + ". "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getFillBlankAndAns(item))
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("正确答案："), _vm._l((_vm.resData.correctAnswers[item.id]), function(ans, indexj) {
      return _c('span', {
        key: index + indexj
      }, [_c('span', [_vm._v(_vm._s(ans.content))]), _vm._v(" "), (indexj < _vm.resData.correctAnswers[item.id].length - 1) ? _c('span', {
        staticClass: "color-info ml-5 mr-5"
      }, [_vm._v("|")]) : _vm._e()])
    })], 2), _vm._v(" "), (item.analysis) ? _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("答案分析："), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.analysis)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    })], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "score-line"
  })]) : _vm._e(), _vm._v(" "), (_vm.resData.questionAnswer.length) ? _c('div', {
    staticClass: "box-shadow-small background-white border-radius exam-topic-item"
  }, [_c('h3', [_vm._v(_vm._s(_vm.num2Chinese(_vm.simpleAnswerIndex)) + "、" + _vm._s(_vm.resData.titles[_vm.simpleAnswerIndex].title) + " ")]), _vm._v(" "), _c('p', [(_vm.subTitle(_vm.simpleAnswerIndex)) ? _c('span', [_vm._v("(" + _vm._s(_vm.subTitle(_vm.simpleAnswerIndex)) + " )")]) : _vm._e()]), _vm._v(" "), _c('div', _vm._l((_vm.resData.questionAnswer), function(item, index) {
    return _c('el-row', {
      key: index
    }, [_c('el-col', {
      attrs: {
        "span": 22
      }
    }, [_c('h4', [_vm._v(_vm._s(index + 1) + "."), _c('span', {
      staticClass: "ques-txt",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "exam-topic-blank-label"
    }, [_vm._v("答案：")]), _vm._v(" "), _c('div', {
      staticClass: "exam-topic-blank block answer-txt"
    }, [_vm._v(_vm._s(_vm.resData.answers[item.id] ? _vm.resData.answers[item.id][0].content : '-') + "\n                                ")])]), _vm._v(" "), _c('p', {
      staticClass: "system-answer"
    }, [_vm._v("答案分析："), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.analysis)
      }
    })])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    })], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "score-line"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.$win.close
    }
  }, [_vm._v("关闭")])], 1)]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1034e462"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/examTopic.vue
// module id = null
// module chunks = 